const currencyListOptions = [
    { value: "USD", label: "United States Dollar", countryCode: "US" },
    { value: "EUR", label: "Euro", countryCode: "EU" },
    { value: "GBP", label: "British Pound Sterling", countryCode: "GB" },
    { value: "CAD", label: "Canadian Dollar", countryCode: "CA" },
    { value: "ARS", label: "Argentine Peso", countryCode: "AR" },
    { value: "AUD", label: "Australian Dollar", countryCode: "AU" },
    { value: "BRL", label: "Brazilian Real", countryCode: "BR" },
    { value: "CLP", label: "Chilean Peso", countryCode: "CL" },
    { value: "CNY", label: "Chinese Yuan", countryCode: "CN" },
    { value: "CZK", label: "Czech Republic Koruna", countryCode: "CZ" },
    { value: "DKK", label: "Danish Krone", countryCode: "DK" },
    { value: "HKD", label: "Hong Kong Dollar", countryCode: "HK" },
    { value: "HUF", label: "Hungarian Forint", countryCode: "HU" },
    { value: "ISK", label: "Icelandic Krona", countryCode: "IS" },
    { value: "INR", label: "Indian Rupee", countryCode: "IN" },
    { value: "JMD", label: "Jamaican Dollar", countryCode: "JM" },
    { value: "JPY", label: "Japanese Yen", countryCode: "JP" },
    { value: "LVL", label: "Latvian Lats", countryCode: "LV" },
    { value: "LTL", label: "Lithuanian Litas", countryCode: "LT" },
    { value: "MXN", label: "Mexican Peso", countryCode: "MX" },
    { value: "NZD", label: "New Zealand Dollar", countryCode: "NZ" },
    { value: "NOK", label: "Norwegian Krone", countryCode: "NO" },
    { value: "PLN", label: "Polish Zloty", countryCode: "PL" },
    { value: "SGD", label: "Singapore Dollar", countryCode: "SG" },
    { value: "ZAR", label: "South African Rand", countryCode: "ZA" },
    { value: "KRW", label: "South Korean Won", countryCode: "KR" },
    { value: "SEK", label: "Swedish Krona", countryCode: "SE" },
    { value: "CHF", label: "Swiss Franc", countryCode: "CH" },
    { value: "TWD", label: "Taiwan New Dollar", countryCode: "TW" },
    { value: "UYU", label: "Uruguayan Peso", countryCode: "UY" },
    { value: "MYR", label: "Malaysian Ringgit", countryCode: "MY" },
    { value: "BSD", label: "Bahamian Dollar", countryCode: "BS" },
    { value: "CRC", label: "Costa Rican Colon", countryCode: "CR" },
    { value: "RON", label: "Romanian Leu", countryCode: "RO" },
    { value: "PHP", label: "Philippine Peso", countryCode: "PH" },
    { value: "AED", label: "United Arab Emirates Dirham", countryCode: "AE" },
    { value: "IDR", label: "Indonesian Rupiah", countryCode: "ID" },
    { value: "TRY", label: "Turkish Lira", countryCode: "TR" },
    { value: "THB", label: "Thai Baht", countryCode: "TH" },
    { value: "TTD", label: "Trinidad and Tobago Dollar", countryCode: "TT" },
    { value: "ILS", label: "Israeli New Sheqel", countryCode: "IL" },
    { value: "SYP", label: "Syrian Pound", countryCode: "SY" },
    { value: "COP", label: "Colombian Peso", countryCode: "CO" },
    { value: "RUB", label: "Russian Ruble", countryCode: "RU" },
    { value: "HRK", label: "Croatian Kuna", countryCode: "HR" },
    { value: "KZT", label: "Kazakhstani Tenge", countryCode: "KZ" },
    { value: "TZS", label: "Tanzanian Shilling", countryCode: "TZ" },
    { value: "SAR", label: "Saudi Riyal", countryCode: "SA" },
    { value: "NIO", label: "Nicaraguan Cordoba", countryCode: "NI" },
    { value: "OMR", label: "Omani Rial", countryCode: "OM" },
    { value: "AMD", label: "Armenian Dram", countryCode: "AM" },
    { value: "CDF", label: "Congolese Franc", countryCode: "CD" },
    { value: "KPW", label: "North Korean Won", countryCode: "KP" },
    { value: "KES", label: "Kenyan Shilling", countryCode: "KE" },
    { value: "KHR", label: "Cambodian Riel", countryCode: "KH" },
    { value: "MVR", label: "Maldivian Rufiyaa", countryCode: "MV" },
    { value: "GTQ", label: "Guatemalan Quetzal", countryCode: "GT" },
    { value: "BZD", label: "Belize Dollar", countryCode: "BZ" },
    { value: "LYD", label: "Libyan Dinar", countryCode: "LY" },
    { value: "DZD", label: "Algerian Dinar", countryCode: "DZ" },
    { value: "BIF", label: "Burundian Franc", countryCode: "BI" },
    { value: "BOB", label: "Bolivian Boliviano", countryCode: "BO" },
    { value: "NGN", label: "Nigerian Naira", countryCode: "NG" },
    { value: "PGK", label: "Papua New Guinean Kina", countryCode: "PG" },
    { value: "ERN", label: "Eritrean Nakfa", countryCode: "ER" },
    { value: "GMD", label: "Gambian Dalasi", countryCode: "GM" },
    { value: "CVE", label: "Cape Verdean Escudo", countryCode: "CV" },
    { value: "BTN", label: "Bhutanese Ngultrum", countryCode: "BT" },
    { value: "UGX", label: "Ugandan Shilling", countryCode: "UG" },
    { value: "MAD", label: "Moroccan Dirham", countryCode: "MA" },
    { value: "MNT", label: "Mongolian Tugrik", countryCode: "MN" },
    { value: "LSL", label: "Lesotho Loti", countryCode: "LS" },
    { value: "TOP", label: "Tongan Pa'anga", countryCode: "TO" },
    { value: "RSD", label: "Serbian Dinar", countryCode: "RS" },
    { value: "HTG", label: "Haitian Gourde", countryCode: "HT" },
    { value: "MGA", label: "Malagasy Ariary", countryCode: "MG" },
    { value: "MZN", label: "Mozambican Metical", countryCode: "MZ" },
    { value: "FKP", label: "Falkland Islands Pound", countryCode: "FK" },
    { value: "BWP", label: "Botswanan Pula", countryCode: "BW" },
    { value: "HNL", label: "Honduran Lempira", countryCode: "HN" },
    { value: "PYG", label: "Paraguayan Guarani", countryCode: "PY" },
    { value: "EGP", label: "Egyptian Pound", countryCode: "EG" },
    { value: "LBP", label: "Lebanese Pound", countryCode: "LB" },
    { value: "ANG", label: "Netherlands Antillean Guilder", countryCode: "CW" },
    { value: "WST", label: "Samoan Tala", countryCode: "WS" },
    { value: "GYD", label: "Guyanaese Dollar", countryCode: "GY" },
    { value: "NPR", label: "Nepalese Rupee", countryCode: "NP" },
    { value: "KMF", label: "Comorian Franc", countryCode: "KM" },
    { value: "IRR", label: "Iranian Rial", countryCode: "IR" },
    { value: "SRD", label: "Surinamese Dollar", countryCode: "SR" },
    { value: "MOP", label: "Macanese Pataca", countryCode: "MO" },
    { value: "BMD", label: "Bermudan Dollar", countryCode: "BM" },
    { value: "ETB", label: "Ethiopian Birr", countryCode: "ET" },
    { value: "JOD", label: "Jordanian Dinar", countryCode: "JO" },
    { value: "MDL", label: "Moldovan Leu", countryCode: "MD" },
    { value: "YER", label: "Yemeni Rial", countryCode: "YE" },
    { value: "BAM", label: "Bosnia-Herzegovina Convertible Mark", countryCode: "BA" },
    { value: "AWG", label: "Aruban Florin", countryCode: "AW" },
    { value: "PEN", label: "Peruvian Nuevo Sol", countryCode: "PE" },
    { value: "KYD", label: "Cayman Islands Dollar", countryCode: "KY" },
    { value: "TND", label: "Tunisian Dinar", countryCode: "TN" },
    { value: "SCR", label: "Seychellois Rupee", countryCode: "SC" },
    { value: "LKR", label: "Sri Lankan Rupee", countryCode: "LK" },
    { value: "DJF", label: "Djiboutian Franc", countryCode: "DJ" },
    { value: "GNF", label: "Guinean Franc", countryCode: "GN" },
    { value: "VUV", label: "Vanuatu Vatu", countryCode: "VU" },
    { value: "SDG", label: "Sudanese Pound", countryCode: "SD" },
    { value: "GEL", label: "Georgian Lari", countryCode: "GE" },
    { value: "FJD", label: "Fijian Dollar", countryCode: "FJ" },
    { value: "DOP", label: "Dominican Peso", countryCode: "DO" },
    { value: "MUR", label: "Mauritian Rupee", countryCode: "MU" },
    { value: "MMK", label: "Myanma Kyat", countryCode: "MM" },
    { value: "LRD", label: "Liberian Dollar", countryCode: "LR" },
    { value: "BBD", label: "Barbadian Dollar", countryCode: "BB" },
    { value: "VND", label: "Vietnamese Dong", countryCode: "VN" },
    { value: "UAH", label: "Ukrainian Hryvnia", countryCode: "UA" },
    { value: "IQD", label: "Iraqi Dinar", countryCode: "IQ" },
    { value: "BGN", label: "Bulgarian Lev", countryCode: "BG" },
    { value: "KGS", label: "Kyrgystani Som", countryCode: "KG" },
    { value: "RWF", label: "Rwandan Franc", countryCode: "RW" },
    { value: "BHD", label: "Bahraini Dinar", countryCode: "BH" },
    { value: "UZS", label: "Uzbekistan Som", countryCode: "UZ" },
    { value: "PKR", label: "Pakistani Rupee", countryCode: "PK" },
    { value: "MKD", label: "Macedonian Denar", countryCode: "MK" },
    { value: "AFN", label: "Afghan Afghani", countryCode: "AF" },
    { value: "NAD", label: "Namibian Dollar", countryCode: "NA" },
    { value: "BDT", label: "Bangladeshi Taka", countryCode: "BD" },
    { value: "AZN", label: "Azerbaijani Manat", countryCode: "AZ" },
    { value: "SOS", label: "Somali Shilling", countryCode: "SO" },
    { value: "QAR", label: "Qatari Rial", countryCode: "QA" },
    { value: "PAB", label: "Panamanian Balboa", countryCode: "PA" },
    { value: "KWD", label: "Kuwaiti Dinar", countryCode: "KW" }
];

module.exports = { currencyListOptions }
